module.exports = __webpack_public_path__ + "static/media/savant-ni-white.b03b5c7e.svg";